import { Product, ProductCalculations, ProductWithCalculations, GlobalSettings, StatusType, StatusConfig } from '../types/inventory';

export function calculateMetrics(
  product: Product,
  settings: GlobalSettings
): ProductCalculations {
  const cmd = product.vendasPeriodo / product.diasPeriodo;
  const ddlt = cmd * settings.leadTime;
  const ss = cmd * settings.leadTime;
  const rop = ddlt + ss;
  const cobertura = cmd > 0 ? product.estoqueAtual / cmd : 0;
  const estoqueAlvo = ddlt + ss + (settings.diasCoberturaAlvo * cmd);
  const pedidoSugerido = Math.max(0, estoqueAlvo - product.estoqueAtual);

  return {
    cmd,
    ddlt,
    ss,
    rop,
    cobertura,
    estoqueAlvo,
    pedidoSugerido
  };
}

export function getProductStatus(
  product: Product,
  calculations: ProductCalculations,
  settings: GlobalSettings
): StatusType {
  if (product.estoqueAtual === 0) return 'ruptura';
  if (product.estoqueAtual < calculations.ss) return 'iminente';
  if (product.estoqueAtual >= calculations.ss && product.estoqueAtual <= calculations.rop) return 'minimo';
  if (calculations.cobertura < settings.leadTime) return 'critica';
  if (calculations.cobertura > settings.diasCoberturaAlvo) return 'excesso';
  return 'saudavel';
}

export const statusConfigs: Record<StatusType, StatusConfig> = {
  ruptura: {
    label: 'Ruptura instalada',
    color: 'text-red-900',
    bgColor: 'bg-red-100'
  },
  iminente: {
    label: 'Ruptura iminente',
    color: 'text-orange-900',
    bgColor: 'bg-orange-100'
  },
  minimo: {
    label: 'Perto do mínimo',
    color: 'text-yellow-900',
    bgColor: 'bg-yellow-100'
  },
  critica: {
    label: 'Cobertura crítica',
    color: 'text-purple-900',
    bgColor: 'bg-purple-100'
  },
  excesso: {
    label: 'Excesso',
    color: 'text-blue-900',
    bgColor: 'bg-blue-100'
  },
  saudavel: {
    label: 'Saudável',
    color: 'text-green-900',
    bgColor: 'bg-green-100'
  }
};

export function enrichProductWithCalculations(
  product: Product,
  settings: GlobalSettings
): ProductWithCalculations {
  const calculations = calculateMetrics(product, settings);
  const status = getProductStatus(product, calculations, settings);
  const statusLabel = statusConfigs[status].label;

  return {
    ...product,
    ...calculations,
    status,
    statusLabel
  };
}
